import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { fadeIn, fadeOut } from 'src/app/animations';
import { ContactType } from 'src/app/models/enum/contact-type.enum';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { ButtonIcons } from '../action-button/models/button-icons.enum';
import { SettingsPreferences } from 'src/app/services/ui/models/settings-preferences.model';
import { PersonalDocument } from 'src/app/models/personal-document.model';
import * as moment from 'moment';
import { MatSidenav } from '@angular/material/sidenav';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TokenHelper } from 'src/app/services/helpers/token.helper';
import { JobService } from 'src/app/services/sections/job/job.service';
import { GenericModalComponent } from '../generic-modal/generic-modal.component';
import { PersonalEmail } from 'src/app/models/personal-email.model';
import { JobDocumentsService } from 'src/app/services/sections/job/job-documents.service';
import { MyCloudService } from 'src/app/services/sections/job/my-cloud.service';
import { DocViewerDocumentDetails } from '../document-viewer/document-viewer.component';

@Component({
	selector: 'my-cloud',
	templateUrl: './my-cloud.component.html',
	styleUrls: ['../stylesheets/job-actions.scss', '../stylesheets/job-main.scss', '../stylesheets/job-inputs.scss', '../stylesheets/job-contacts.scss', '../stylesheets/document-viewer.scss', './my-cloud.component.scss'],
	animations: [fadeIn(300), fadeOut(300)]
})
export class MyCloudComponent implements OnInit, OnDestroy, AfterViewInit {

	@ViewChild('sidenav', { static: true }) public sidenav: MatSidenav;
	@ViewChild('emailViewModal', { static: true }) public emailViewModal: GenericModalComponent;

	public customerPreferences: SettingsPreferences;

	public readonly ButtonIcons = ButtonIcons;
	public readonly ContactType = ContactType;

	public documents: PersonalDocument[] = [];
	public selectedDocuments: PersonalDocument[] = [];

	public carriedPayload: any;
	public isOpened = false;
	public viewEmail = false;
	public viewDocument = false;

	public selectedDocumentDetails: DocViewerDocumentDetails;
	public selectedEmailDetails: PersonalEmail;

	public unsubscriber$ = new Subject<void>();
	public documentLoadUnsubscriber$ = new Subject<void>();

	public readonly moment = moment;

	constructor(
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private jobService: JobService,
		private jobDocumentsService: JobDocumentsService,
		private myCloudService: MyCloudService
	) {
		const routingData = this.router.getCurrentNavigation()?.extras.state;

		if (routingData?.carriedPayload) {
			this.selectedDocuments = routingData.selectionData;
			this.carriedPayload = routingData.carriedPayload;
		}
	}

	ngOnInit(): void {
		this.customerPreferences = this.activatedRoute.snapshot.data.customerPreferences;
		this.documents = this.activatedRoute.snapshot.data.documents;
	}

	ngAfterViewInit(): void {
		GlobalSettingsService.isGlobalLoaderLoading = false;
		GlobalSettingsService.isSecondaryLoaderLoading = false;
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
		this.documentLoadUnsubscriber$.next();
		this.documentLoadUnsubscriber$.complete();
	}

	public navigateWithData(subpage: string, data?: any): void {
		const state = {} as any;

		if (data) {
			state.selectionData = data;
		}

		if (this.carriedPayload) {
			state.carriedPayload = this.carriedPayload;
		}

		this.router.navigate([subpage], { relativeTo: this.activatedRoute, state });
	}

	public toggleSlide(): void {
		this.isOpened = !this.isOpened;
		this.sidenav.toggle();
	}

	public showDocument(document: PersonalDocument): void {
		this.selectedDocumentDetails = null;
		this.selectedEmailDetails = null;
		this.viewEmail = false;
		this.viewDocument = true;

		if (!this.isOpened) {
			this.toggleSlide();
		}

		const extension = document.documentName.split('.').reduce((prev, current) => current);
		const name = document.documentName ? document.documentName + '.' + extension : document.documentName;

		this.jobDocumentsService
			.getJobDocument(TokenHelper.getToken(this.activatedRoute), document.documentId)
			.pipe(
				takeUntil(this.unsubscriber$),
				takeUntil(this.documentLoadUnsubscriber$)
			)
			.subscribe((content) => {
				this.selectedDocumentDetails = {
					documentId: document.documentId,
					content,
					documentDisplayName: name,
					documentDownloadName: name
				};
			});
	}

	public showEmail(document: PersonalDocument): void {
		this.selectedDocumentDetails = null;
		this.selectedEmailDetails = null;
		this.viewEmail = true;
		this.viewDocument = false;

		if (!this.isOpened) {
			this.toggleSlide();
		}

		this.myCloudService
			.getMyCloudEmail(TokenHelper.getToken(this.activatedRoute), document.emailId)
			.pipe(
				takeUntil(this.unsubscriber$)
			)
			.subscribe(email => this.selectedEmailDetails = email);
	}
}
